<header #udHeader class="w-100">
  <div
    class="d-flex flex-row justify-content-between align-items-center py-3 px-3 text-sm w-100 min-100">
    <div class="d-flex w-100">
      <div class="mr-5">
        <a class="logo-link" (click)="canUserAccessNewQuote && openNewQuote()">
          <img
            src="assets/svg/img-unity-direct-logo.svg"
            alt="Unity Direct Logo" />
        </a>
      </div>

      <div class="quote-status-payment-wrapper">
        <div
          class="text-right text-sm-left ml-3 mt-1"
          *ngIf="!isBillingPage && canUserAccessNewQuote">
          Status
          <div class="text-primary font-semibold">
            {{ loanStatus }}
          </div>
        </div>

        <div
          class="estimated-monthly-payment-box"
          *ngIf="isShowEstimatedMonthlyPayment">
          <div class="estimated-monthly-copy">
            <span class="ribbon">Estimated</span> Monthly Payment
          </div>
          <div class="estimated-monthly-amount">
            {{ getMonthlyPaymentValue() | currency }}
          </div>
        </div>
      </div>
    </div>

    <div
      class="text-right d-none d-sm-block w-100"
      *ngIf="canUserAccessNewQuote || canUserAccessBilling">
      <nav class="d-flex flex-row justify-content-end">
        <a
          class="mx-2"
          [class.selected]="!isShowMegaMenu && isNewQuote"
          (click)="openNewQuote()"
          *ngIf="canUserAccessNewQuote"
          >New Quote</a
        >
        <a
          class="mx-2"
          [class.selected]="isQuotesMegaMenu"
          (click)="openMegaMenu('quotes')"
          >Search</a
        >
        <a
          class="mx-2"
          [class.selected]="!isShowMegaMenu && isBillingPage"
          (click)="openBillingPage()"
          *ngIf="canUserAccessBilling"
          >Billing</a
        >
        <a
          class="mx-2"
          [class.selected]="isResourcesMegaMenu"
          (click)="openMegaMenu('resources')"
          >Resources</a
        >
        <ng-container *ngIf="isShowAdmin">
          <a
            class="mx-2"
            [class.selected]="isAdminPage"
            (click)="openAdminPage()"
            >Admin</a
          >
        </ng-container>
      </nav>
    </div>
  </div>
  <app-alert-container> </app-alert-container>
</header>
<div class="mega-menu-container" *ngIf="isShowMegaMenu" #megaMenu>
  <div class="mega-menu">
    <button (click)="closeMegaMenu()" class="btn-close">
      <mat-icon>close</mat-icon>
    </button>
    <div *ngIf="isQuotesMegaMenu">
      <h1 class="mat-display-1 mega-menu-titles">
        Search with the options below:
      </h1>
      <div class="mega-menu-content">
        <form [formGroup]="searchQuoteForm">
          <div class="search-field-row ml-0 mt-2">
            <div class="d-flex flex-wrap gap-2">
              <mat-form-field
                class="custom search-input mr-3"
                appearance="outline">
                <mat-label>First Name</mat-label>
                <input
                  matInput
                  placeholder="First Name"
                  formControlName="firstName" />
              </mat-form-field>
              <mat-form-field
                class="custom search-input mr-4"
                appearance="outline">
                <mat-label>Last Name</mat-label>
                <input
                  matInput
                  placeholder="Last Name"
                  formControlName="lastName" />
              </mat-form-field>
              <mat-form-field
                class="custom search-input mr-3"
                appearance="outline">
                <mat-label>Email</mat-label>
                <input matInput placeholder="Email" formControlName="email" />
              </mat-form-field>
              <mat-form-field
                class="custom search-input mr-4"
                appearance="outline">
                <mat-label>Account Number</mat-label>
                <input
                  matInput
                  placeholder="Account Number"
                  formControlName="accountNumber" />
              </mat-form-field>
              <mat-form-field
                class="custom search-input mr-4"
                appearance="outline">
                <mat-label>VIN</mat-label>
                <input matInput placeholder="VIN" formControlName="vin" />
              </mat-form-field>
              <mat-form-field
                class="custom search-input mr-4"
                appearance="outline">
                <mat-label>SWBC Ref #</mat-label>
                <input
                  matInput
                  placeholder="SWBC Ref #"
                  formControlName="swbcRefNum" />
              </mat-form-field>
              <div class="mt-1">
                <button mat-flat-button color="primary" (click)="searchQuote()">
                  Search
                </button>
              </div>
            </div>
          </div>
        </form>
        <p
          *ngIf="searchResultReturned && !searchResult?.length && !searchError"
          class="mb-4">
          No Data Found
        </p>
        <p *ngIf="!searchResult?.length && searchError" class="mb-4">
          We are unable to retrieve results at this time. Please try again
          later.
        </p>
        <div
          class="d-flex justify-content-start mt-3"
          *ngIf="searchResult?.length">
          <h3 class="font-bold">Results</h3>
        </div>
        <mat-spinner
          [diameter]="20"
          *ngIf="isResultLoading && !searchError"
          class="mt-1 ml-1"></mat-spinner>
        <div
          class="results-table"
          *ngIf="searchResultReturned && searchResult?.length">
          <table>
            <thead>
              <tr class="pt-3">
                <th>
                  <p class="font-bold">Name</p>
                </th>
                <th>
                  <p class="font-bold">VIN</p>
                </th>
                <th>
                  <p class="font-bold">Loan Status</p>
                </th>
                <th>
                  <p class="font-bold">Sold Date</p>
                </th>
                <th>
                  <p class="font-bold">Address</p>
                </th>
                <th>
                  <p class="font-bold">Account#</p>
                </th>
                <th>
                  <p class="font-bold">SWBC Ref#</p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let res of searchResult">
                <td>
                  <a
                    class="text-link"
                    (click)="
                      navigateToReviewSearchResults(
                        res.id,
                        res.finance.loanStatus
                      )
                    "
                    >{{ res.borrower.firstName }} {{ res.borrower.lastName }}</a
                  >
                </td>
                <td>
                  <p>{{ res.vehicle.vin | emptyValue }}</p>
                </td>
                <td>
                  <p *ngIf="res.finance.loanStatus === 0">Proposal</p>
                  <p *ngIf="res.finance.loanStatus === 1">Booking</p>
                  <p *ngIf="res.finance.loanStatus === 3">Void</p>
                  <p *ngIf="res.finance.loanStatus === 4">None</p>
                </td>
                <td>
                  <p>
                    {{ res.finance.loanDate | date: 'MM/dd/yyyy' | emptyValue }}
                  </p>
                </td>
                <td>
                  <p>
                    {{ res.borrower.address1 | emptyValue }},
                    {{ res.borrower.city | emptyValue }}
                  </p>
                </td>
                <td>
                  <p>{{ res.borrower.accountNumber | emptyValue }}</p>
                </td>
                <td>
                  <p>{{ res.id | emptyValue }}</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="d-flex justify-content-start mt-4">
          <h3 class="mb-2">Recent Activity</h3>
          <mat-spinner
            [diameter]="20"
            *ngIf="isContentLoading"
            class="mt-1 ml-2"></mat-spinner>
        </div>
        <p *ngIf="!quoteActivityArr.length && !isContentLoading">
          No recent Activity
        </p>
        <div class="activity-table" *ngIf="quoteActivityArr.length">
          <table>
            <thead>
              <tr class="pt-3">
                <th>
                  <p class="font-bold">Name</p>
                </th>
                <th>
                  <p class="font-bold">VIN</p>
                </th>
                <th>
                  <p class="font-bold">Loan Status</p>
                </th>
                <th>
                  <p class="font-bold">Sold Date</p>
                </th>
                <th>
                  <p class="font-bold">SWBC Ref #</p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let activity of quoteActivityArr">
                <td>
                  <a
                    class="text-link"
                    (click)="
                      navigateToReview(activity.swbcRefNum, activity.loanStatus)
                    ">
                    {{ activity.firstName }}
                    {{ activity.lastName }}
                  </a>
                </td>
                <td>
                  <p>{{ activity.vin | emptyValue }}</p>
                </td>
                <td>
                  <p>{{ activity.loanStatus | emptyValue }}</p>
                </td>
                <td>
                  <p>{{ activity.productSoldDate | emptyValue }}</p>
                </td>
                <td>
                  <p>{{ activity.swbcRefNum | emptyValue }}</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <p *ngIf="isBillingMegaMenu">Billing</p>
    <div *ngIf="isResourcesMegaMenu">
      <h1 class="mat-display-1 mega-menu-titles">Resources</h1>
      <p *ngIf="!documents.length && !isContentLoading">
        No resources available
      </p>
      <div
        *ngIf="!documents.length && isContentLoading"
        class="d-flex justify-content-center">
        <mat-spinner
          [diameter]="20"
          *ngIf="isContentLoading"
          class="mt-3"></mat-spinner>
      </div>
      <div class="column-list" *ngIf="documents.length && !isContentLoading">
        <span *ngFor="let doc of documents | slice: docStart : docEnd">
          <a
            href="{{ doc.documentLink }}"
            target="_blank"
            matTooltip="{{ doc.documentDescription }}"
            matTooltipPosition="above">
            <span class="mb-1">{{ doc.documentDescription }}</span>
          </a>
        </span>
      </div>
      <div
        class="d-flex justify-content-center align-items-center mt-4"
        *ngIf="documents.length">
        <button
          mat-icon-button
          color="primary"
          class="mr-2"
          (click)="showPrevDocs()"
          [disabled]="docStart === 0"
          matTooltip="Previous"
          matTooltipPosition="above">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <p class="m-0">
          {{ docStart + 1 }}-{{ docEnd }} of {{ documents.length }}
        </p>
        <button
          mat-icon-button
          color="primary"
          class="ml-2"
          (click)="showNextDocs()"
          [disabled]="docEnd === documents.length"
          matTooltip="Next"
          matTooltipPosition="above">
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
